import { render } from "./disclaimer.vue?vue&type=template&id=4891a87f&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=4891a87f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4891a87f"

export default script